import {
  FETCH_RECOMMENDED_LIST,
  FETCH_RECOMMENDED_LIST_START,
  FETCH_RECOMMENDED_LIST_ERROR,
} from "../constants/ActionTypes";

const INITIAL_STATE = {
  isLoading: false,
  hasError: false,
  items: null,
};

export default function recommendedListReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_RECOMMENDED_LIST_START:
      return { ...state, isLoading: true, hasError: false };
    case FETCH_RECOMMENDED_LIST:
      return { ...state, items: action.payload, isLoading: false, hasError: false };
    case FETCH_RECOMMENDED_LIST_ERROR:
      return { ...state, isLoading: false, hasError: true };
    default:
      return state;
  }
}
